export interface IGroupButton {
  label: string;
  name: string;
  icon?: string;
  isSvg?: boolean;
  color?: string;
}

export enum MapTableType {
  Default = 'default',
  Otdr = 'otdr',
  CheckIn = 'checkIn'
}

export interface IMapTable {
  id?: any;
  url: string;
  pagination?: boolean;
  marker?: string;
  dataset?: string;
  groupButtons?: IGroupButton[];
  title?: string;
  excelUrl?: string;
  csvUrl?: string;
  pdfUrl?: string;
  showLevels?: boolean;
  method?: 'GET' | 'POST';
  body?: any;
  count?: boolean;
  pinnableRow?: boolean;
  infoColumn?: boolean;
  queryGeometry?: any;
  filters?: Record<string, any>;
  queryName?: string;
}

export interface IMapTableData {
  rows: number;
  tab_name: string;
  tab_description?: string;
  data: IMapSource[];
  hide?: boolean;
  showGeometries?: boolean;
  icon: {
    type: string; // material o svg USARE MATERIAL PER NON COMPLICARE
    name?: string; // nome icona material o url all'svg
    path?: string; // path svg
    color?: string; // PER SVG
  };
  name?: string;
}

export interface IMapSource {
  id?: any;
  properties: any;
  name?: string;
  geometry?: any;
  type?: string;
}

export interface IResponse {
  data: any[];
  error: number;
  errorDescription: number;
  message: string;
}
